import React, {useMemo, useState} from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import {CONTACT_ADD, CONTACT_FORM, CONTACT_ITEM, CONTACT_ITEM_FORM,} from "v4/data/apiRoutes";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import ShowEntityLayout from "v4/layouts/ShowEntityLayout/ShowEntityLayout";
import ProspectTabBackButton from "v4/components/utils/ProspectTabBackButton/ProspectTabBackButton";
import ProspectTabEditButton from "v4/components/utils/ProspectTabEditButton/ProspectTabEditButton";
import ProspectTabShowActions
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectTabShowActions/ProspectTabShowActions";

export default function BaseContactTab({
                                           listingComponent,
                                           mailComponent = null,
                                           onGetData: onGetDataFromProps = null,
                                           fetchFormParameters: fetchFormParametersFromProps,
                                       }) {
    const {currentRoute} = useNavigation();
    const isShow = currentRoute.routeType === 'SHOW';
    const isEdit = currentRoute.routeType === 'EDIT';
    const isAdd = currentRoute.routeType === 'ADD';
    const isMail = currentRoute.routeType === 'MAIL';
    const isListing = currentRoute.routeType === 'LISTING';

    const {prospect: prospectId, contact: showId} = currentRoute.params;
    const [contactData, setContactData] = useState(null);

    const onGetData = (data) => {
        const hydraMember = data?.['hydra:member'];
        setContactData(hydraMember ?? data);
        onGetDataFromProps && onGetDataFromProps(data);
    }

    const fetchFormParameters = useMemo(() => ({
        id: showId,
        prospectId,
        ...(fetchFormParametersFromProps ?? {})
    }), [showId, prospectId, fetchFormParametersFromProps]);

    return (
        <>
            <ToggleComponent isShowing={isListing}>
                {listingComponent}
            </ToggleComponent>

            {mailComponent && (
                <ToggleComponent isShowing={isMail}
                                 shouldRemoveFromDom={true}
                                 className="prospect-tab__prospect mail">
                    {mailComponent}
                </ToggleComponent>
            )}

            <ToggleComponent isShowing={isShow && !isEdit}
                             shouldRemoveFromDom={true}
                             className="prospect-tab__prospect showing">
                <div className="prospect-tab__prospect__header">
                    <ProspectTabBackButton/>
                    <ProspectTabEditButton/>
                    {contactData?.metadata?.showActions && (
                        <ProspectTabShowActions showId={showId}
                                                prospectId={prospectId}
                                                showActions={contactData.metadata.showActions}/>
                    )}
                </div>
                <ShowEntityLayout entityId={showId}
                                  onGetData={onGetData}
                                  entityRouteName={CONTACT_ITEM_FORM}
                                  fetchFormParameters={fetchFormParametersFromProps}/>
            </ToggleComponent>

            <ToggleComponent isShowing={isAdd || isEdit}
                             shouldRemoveFromDom={true}
                             className="prospect-tab__prospect editing">
                <FormEntityLayout formRouteName={isAdd ? CONTACT_FORM : CONTACT_ITEM_FORM}
                                  submitRouteName={isAdd ? CONTACT_ADD : CONTACT_ITEM}
                                  fetchFormParameters={fetchFormParameters}
                                  whenSubmitted={whenSubmitted}/>
            </ToggleComponent>
        </>
    )
}

function whenSubmitted(history) {
    history.push(history.location.pathname.replace(/\/(edit|add)$/, ''), {hasToRefresh: true});
}
